<template>
    <div>
        <base-dialog :loading="loading" :value="dialog" :width="560" :title="$t('common.save_in_folder')" @input="onInput" @close="hide">
            <div class="sec-hd">
                <span class="sec-tit">{{ $t('common.your_folders') }}</span>
                <button type="button" class="sec-add" @click="showAdminFolders">
                    <v-icon size="13">mdi-plus</v-icon>
                    {{ $t('common.folder') }}
                </button>
            </div>
            <div v-if="currentFoldersType.length" class="fol-grid">
                <folder-card v-for="folder in currentFolders" :key="folder.id" :folder="folder"
                    :is-active="isActiveFolder(folder)" @click="onSelectFolder(folder)" no-edit />
            </div>
            <div v-else class="fol-empty">{{ $t('common.no_folders') }}</div>
            <kimsa-pagination v-if="pageCount > 1" class="mt-3" center @page="page = $event - 1" :pageCount="pageCount"
                :total-visible="isMobile ? 5 : 7" :value="page + 1" />

            <template #footer>
                <dialog-actions :confirm-label="$t('common.save')" :disabled="disabled" :loading="loading"
                    @cancel="hide" @confirm="save" />
            </template>
        </base-dialog>

        <admin-folders-dialog ref="folders" :type="type" :coach-id="coachId" is-second-dialog />
    </div>
</template>

<script>
import { db } from "@/utils/Firebase";
import { mapState, mapActions } from "vuex";
import FolderCard from '@/components/common/cards/FolderCard'
import AdminFoldersDialog from '@/components/coach/AdminFoldersDialog.vue';
import KimsaPagination from '@/components/common/KimsaPagination'
import BaseDialog from '@/components/common/BaseDialog';
import DialogActions from '@/components/common/DialogActions';

export default {
    components: { FolderCard, AdminFoldersDialog, KimsaPagination, BaseDialog, DialogActions },
    name: "SaveInFolderDialog",
    props: {
        currentId: {
            type: String,
            default: null,
        },
        defaultFolder: {
            type: String,
            default: null,
        },
        type: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            dialog: false,
            loading: false,
            folder: null,
            page: 0,
        }
    },
    computed: {
        ...mapState(['folders']),
        disabled(vm = this) {
            return (!vm.folder && !vm.defaultFolder) || vm.defaultFolder === vm.folder?.id
        },
        currentFoldersType(vm = this) {
            return vm.folders.filter(folder => folder.type === vm.type) || []
        },
        currentFolders(vm = this) {
            let currentPage = vm.page * 6
            return vm.currentFoldersType.slice(currentPage, currentPage + 6)
        },
        pageCount(vm = this) {
            return Math.ceil(vm.currentFoldersType.length / 6)
        },
        coachId(vm = this) {
            return vm.currentUser?.uid || null
        },
    },
    async mounted() {
        const vm = this
        if (vm.folders.length === 0) await vm.bindFolders(vm.currentUser.uid)
        vm.setDefaults()
    },
    methods: {
        ...mapActions(['bindFolders']),
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        onInput(val) {
            if (!val) this.hide()
        },
        reset() {
            const vm = this
            vm.folder = null
            vm.$emit('cancel')
        },
        onSelectFolder(folder) {
            const vm = this
            if (vm.folder?.id === folder?.id) return vm.folder = null
            vm.folder = folder
        },
        isActiveFolder(folder) {
            const vm = this
            return vm.folder?.id === folder.id
        },
        async save() {
            const vm = this
            await vm.withLoading(async () => {
                await db.collection(vm.type).doc(vm.currentId).update({ folder: vm.folder?.id || null })
                vm.$emit('saved', vm.folder?.id || null)
                vm.hide()
                vm.toast(vm.$t('common.changes_saved'))
            })
        },
        setDefaults() {
            const vm = this
            if (vm.defaultFolder) vm.folder = vm.currentFoldersType.find(folder => vm.defaultFolder === folder.id) || null
        },
        showAdminFolders() {
            const vm = this
            vm.$refs.folders.show()
        },
    },
    watch: {
        defaultFolder() {
            this.setDefaults()
        }
    }
}
</script>

<style scoped>
.sec-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.sec-tit {
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
}

.sec-add {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    height: 26px;
    padding: 0 10px;
    border-radius: 6px;
    border: 1px solid rgba(51, 153, 153, .3);
    background: none;
    color: var(--v-accent-base);
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: all .15s;
}

.sec-add:hover {
    background: rgba(51, 153, 153, .08);
}

.sec-add .v-icon {
    color: inherit !important;
}

.fol-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
}

.fol-empty {
    text-align: center;
    font-size: 13px;
    color: var(--v-txtMuted-base);
    padding: 24px 0;
}

@media (max-width: 600px) {
    .fol-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}
</style>